import * as Yup from 'yup';
import { HevoEntity } from '../../../core/interfaces/hevo-entity';
import PipelinesAPI from '../../../containers/pipeline/api/PipelinesAPI';
import { AccountEntityTypes } from '../interfaces';

export const validateAdsAccountRequest = (sourceTypeIdentifier, oAuthToken) => {
  if (sourceTypeIdentifier === 'GOOGLE_ADS') {
    return PipelinesAPI.getAdwordsManagerProfiles(undefined, oAuthToken);
  }

  if (sourceTypeIdentifier === 'GOOGLE_ANALYTICS') {
    return PipelinesAPI.getGAViews(oAuthToken);
  }

  if (sourceTypeIdentifier === 'GOOGLE_CM') {
    return PipelinesAPI.getGCMProfilesAndReportTypes(oAuthToken);
  }

  if (sourceTypeIdentifier === 'FACEBOOK_ADS') {
    return PipelinesAPI.getFBAAccounts(oAuthToken, { page: 1, limit: 1 });
  }

  if (sourceTypeIdentifier === 'AMAZON_ADS') {
    return PipelinesAPI.getAmazonAdsProfiles(oAuthToken);
  }

  return null;
};

export const TARGET_NAME = 'TARGET_NAME';

export const validationSchema = Yup.object({
  targetName: Yup.string().required()
});

export const convertHevoEntityToAccountEntityTypes = (hevoEntity: HevoEntity) => {
  switch (hevoEntity) {
    case HevoEntity.DESTINATION:
      return AccountEntityTypes.DESTINATION;
    case HevoEntity.SOURCE:
      return AccountEntityTypes.SOURCE;
    case HevoEntity.ACTIVATION_TARGET:
      return AccountEntityTypes.TARGET;
    default:
      return null;
  }
};
